import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const WarningSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9957 22.0044C17.4667 22.0044 22 17.4778 22 12.0044C22 6.53098 17.458 2.00439 11.9869 2.00439C6.5207 2.00439 2 6.53098 2 12.0044C2 17.4778 6.52941 22.0044 11.9957 22.0044ZM11.9957 20.5316C7.27809 20.5316 3.48562 16.7327 3.48562 12.0044C3.48562 7.27606 7.26938 3.47716 11.9869 3.47716C16.7132 3.47716 20.5192 7.27606 20.5192 12.0044C20.5192 16.7327 16.7219 20.5316 11.9957 20.5316ZM11.9869 13.7853C12.4122 13.7853 12.6603 13.5293 12.669 13.0708L12.7978 7.8165C12.7978 7.358 12.454 7.02356 11.9782 7.02356C11.4986 7.02356 11.1634 7.34928 11.1721 7.80779L11.2962 13.0708C11.3049 13.5293 11.5491 13.7853 11.9869 13.7853ZM11.9869 16.9246C12.5192 16.9246 12.9797 16.491 12.9797 15.9663C12.9797 15.4251 12.5279 15.008 11.9869 15.008C11.4508 15.008 10.999 15.4338 10.999 15.9663C10.999 16.4822 11.4595 16.9246 11.9869 16.9246Z"
        fill={color}
      />
    </svg>
  );
};

export { WarningSvg };
